import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';

import { getThemeColor } from '../../utils/common';
import { Themes } from '../../constants';
import LogoIcon from '../svgs/LogoIcon';

interface FHWaveLoaderProps {
  text?: string;
}

const StyledBox = styled(Box)(() => ({
  '&.wave-animation > *': {
    transform: 'linear',
  },

  '&.wave-animation > :nth-of-type(1)': {
    animation: 'wave 2s infinite 0s',
  },
  '&.wave-animation > :nth-of-type(2)': {
    animation: 'wave 2s infinite 0.4s',
  },
  '&.wave-animation > :nth-of-type(3)': {
    animation: 'wave 2s infinite 0.8s',
  },

  '&.wave-animation > :nth-of-type(4)': {
    animation: 'wave 2s infinite 1.2s',
  },

  '&.wave-animation > :nth-of-type(5)': {
    animation: 'wave 2s infinite 1.6s',
  },

  '@keyframes wave': {
    '0%': {
      transform: 'scale(1)',
    },
    '50%': {
      transform: 'scale(0.4)',
    },
    '100%': {
      transform: 'scale(1)',
    },
  },
}));

const FHWaveLoader: React.FC<FHWaveLoaderProps> = ({ text }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          maxWidth: '60%',
          gap: 4,
        }}
      >
        <StyledBox className="wave-animation" sx={{ display: 'flex', gap: 2 }}>
          {[...Array(5)].map((_, index) => (
            <LogoIcon
              key={index}
              color={getThemeColor(Themes.Primary).primary}
              width={40}
              height={40}
            />
          ))}
        </StyledBox>
        {text && (
          <Typography style={{ color: getThemeColor(Themes.Primary).primary, fontSize: 21 }}>
            {text}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default FHWaveLoader;
